import React from "react"
import "./style.scss"
// import bannerImage from "../../images/homepage_banner.png"
import hash from "../../images/banners/hash1.png"
import werselSlide from "../../images/banners/wersel-slide.png"
import capture from "../../images/desktopHash.png"
import captureMob from "../../images/mobileHash.png"
import banner from "../../images/banner.gif"
import bannerMob from "../../images/bannerMob.gif"
import { Button, useTheme, makeStyles } from "@material-ui/core"
import { navigate } from "gatsby"

const useStyles = makeStyles(theme => ({
  bookdemoBtn: {
    borderRadius: '22.4225px',
    background: 'conic-gradient(from 180deg at 50% 50%, #6FC0CE -103.12deg, #66B185 70.56deg, #67B48D 136.88deg, #6FC0CE 256.87deg, #66B185 430.56deg)',
    textTransform: 'none',
  },
}))

const BannerSection = ({ bannerImg, bannerBG, title, content }) => {

  const classes = useStyles()
  const theme = useTheme()

  return (
    <div className="homepageBanner">
      {/* <div className="bannerContainer">
        <img src={bannerImage} alt="bannerImage" />
        <div className="bannerHeader">
          <h1 className="bannerTitle">Find true power In your data.</h1>
          <p className="bannerSubTitle">
            Wesel is a powerful brand collaborative and analytics platform can
            access your scattered data from every channel, collect and normalize
            it
          </p>
        </div>
      </div> */}
      {/* <div class="container-fluid">
        <div class="row">
          <div class="image-text-overlay text-middle-left col-sm-6 col-md-12">
            <p>
              <span class="overlay-title">middle left</span>
              <br></br>
              <span class="overlay-subtext">This is subtext.</span>
            </p>
          </div>
        </div>
      </div> */}

      <div className="container-fluid bannerContainer">
        {/* <div className="bannerImage">
          <img src={bannerImg} alt="bannerImage" />
        </div> */}
        <div
          className="row bannerRow"
          style={{
            // background: `url(${bannerBG})`,
            backgroundPosition: "center",
            backgroundSize: "cover",
            backgroundColor: '#F4F7F8',
          }}
        >
          {/* <div>
            <img className="bannerImage" src={banner} alt='img' style={{ width: '1586px' }} />
            <img className="bannerImageMob" src={bannerMob} alt='img' style={{ width: '1450px' }} />
          </div> */}
          <div className="bannerHeader col-sm-5	col-md-5	col-lg-5">
            <div className="bannerImage">
            <img src={bannerImg} alt="bannerImage" />
            </div>
          </div>
          <div className="rowBannerImage col-sm-7	col-md-7	col-lg-7">
            {/* <img src={hash} alt="rowBannerImage" /> */}
            <p className="bannerHead">{title}</p>
            <p className="bannerTitle">{content}</p>
            <div>
            <Button className={classes.bookdemoBtn} variant="contained" onClick={()=> navigate(`/contact`)}> Book Demo </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default BannerSection
